import { Icon, ICONS } from 'components/Icons';
import { Modal } from 'react-bootstrap';
import UserExtensionActionsHistory from './UserExtensionActionsHistory';

import './UserExtensionActionsHistoryModal.scss';

export function UserExtensionActionsHistoryModal({ userId, onClose }) {
  return (
    <Modal show>
      <Modal.Header>
        <Modal.Title>
          Extension Actions
          <Icon
            icon={ICONS.CLOSE}
            className="pull-right cursor-pointer"
            onClick={onClose}
          />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <UserExtensionActionsHistory userId={userId} />
      </Modal.Body>
    </Modal>
  );
}
